import { MailMigrationWarningKey } from '../mail_migration';
import { validateEnumTranslations } from '../../safety_checks';

export const TRANSLATE_KEY_MAIL_MIGRATION_WARNING = 'MAIL_MIGRATION_WARNING_';

export const MailMigrationWarningKeyTranslation = {
  'fr-FR': {
    [`${TRANSLATE_KEY_MAIL_MIGRATION_WARNING}${MailMigrationWarningKey.ALIASES}`]:
      "Alias d'adresse non repris : prévenir le pro (adresse principale à donner, ou alias à recréer plus tard)",
    [`${TRANSLATE_KEY_MAIL_MIGRATION_WARNING}${MailMigrationWarningKey.SHARED_MAILBOXES}`]:
      'Boîtes partagées non reprises',
    [`${TRANSLATE_KEY_MAIL_MIGRATION_WARNING}${MailMigrationWarningKey.MAILING_LISTS}`]:
      'Groupes de distribution non repris',
    [`${TRANSLATE_KEY_MAIL_MIGRATION_WARNING}${MailMigrationWarningKey.RESOURCE_ACCOUNTS}`]:
      'Comptes ressources (salles, matériel) non repris',
    [`${TRANSLATE_KEY_MAIL_MIGRATION_WARNING}${MailMigrationWarningKey.CONTACTS_CALENDARS}`]:
      'Contacts, agendas et tâches ne sont jamais repris : demander au pro de les exporter avant la bascule',
  },
};

//DONT TOUCH below this line
validateEnumTranslations(
  MailMigrationWarningKey,
  MailMigrationWarningKeyTranslation,
  TRANSLATE_KEY_MAIL_MIGRATION_WARNING,
  true,
);
